import React, { useEffect, useRef, useState } from "react";
import ReactApexChart from "react-apexcharts";
// import shortList from "../../assets/images/shortlist.jpg";
import { motion } from "framer-motion";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import bgImage from "../../assets/images/bg-img.jpg";
import html2pdf from "html2pdf.js";
import { useInterview } from "../../services/InterviewProgressContext";

const CandidateDashboard = ({ jd_id, candidate_id }) => {
  const [searchParams] = useSearchParams();
  const JDid = searchParams.get("id");
  const candidate_ID = searchParams.get("candidate_id");
  const id = jd_id ? jd_id : JDid;
  const candidateID = candidate_id ? candidate_id : candidate_ID;

  const [candidateData, setCandidateData] = useState();
  const [blockTwoData, setBlockTwoData] = useState();
  const [McqScrore, setMcqScore] = useState(0);
  const [interviewScore, setInterviewScore] = useState(0);
  const [McqScroreBar, setMcqScoreBar] = useState(0);
  const [interviewScoreBar, setInterviewScoreBar] = useState(0);
  const [globalMcqScroreBar, setGlobalMcqScoreBar] = useState(0);
  const [globalInterviewScoreBar, setGlobalInterviewScoreBar] = useState(0);
  const { goToStep } = useInterview();

  const pdfRef = useRef(null);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     await candidateDetails();
  //     await candidateDetailsGraphs();
  //     await dashboardScreenshot();

  //     setTimeout(() => {
  //       generatePDF();
  //     }, 2000);

  //     await sendEmail();
  //   };

  //   fetchData();
  // }, []);
  useEffect(() => {
    const fetchData = async () => {
      await candidateDetails();
      await candidateDetailsGraphs();
      setTimeout(() => {
        generatePDFAndSend();
      }, 2000);
      // await sendEmail();
    };

    fetchData();
  }, []);

  // const generatePDF = () => {
  //   const element = pdfRef.current;
  //   const opt = {
  //     margin: 0.5,
  //     filename: `${candidateData?.first_name || "Candidate"}_report.pdf`,
  //     image: { type: "jpeg", quality: 0.98 },
  //     html2canvas: { scale: 2 },
  //     jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
  //   };

  //   html2pdf().set(opt).from(element).save();
  // };

const generatePDFAndSend = () => {
  const element = pdfRef.current;

  // Hide profile image temporarily
  const img = element.querySelector("img");
  const originalDisplay = img?.style.display;
  if (img) img.style.display = "none";

  const fileName = `${candidateData?.first_name || "Candidate"}_report.pdf`;

  const opt = {
    margin: 0,
    filename: fileName,
    image: { type: "jpeg", quality: 1 },
    html2canvas: { scale: 3, scrollY: -window.scrollY },
    jsPDF: {
      unit: "px",
      format: [1200, element.scrollHeight],
      orientation: "portrait",
    },
  };

  html2pdf()
    .set(opt)
    .from(element)
    .outputPdf("blob")
    .then(async (pdfBlob) => {
      if (img) img.style.display = originalDisplay;

      const formData = new FormData();
      formData.append(
        "file",
        new File([pdfBlob], fileName, { type: "application/pdf" })
      );
      formData.append("jd_id", id);
      formData.append("candidate_id", candidateID);

      try {
        await axios.post(
          `${process.env.REACT_APP_API_KEY}/dashboard_capture_screenshot`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        await sendEmail();
      } catch (error) {
        console.error("Error uploading PDF:", error);
      }
    })
    .catch((err) => {
      if (img) img.style.display = originalDisplay;
      console.error("PDF generation error:", err);
    });
};


  const sendEmail = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_KEY}/send_email?jd_id=${id}&candidate_id=${candidateID}`,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      goToStep("reportGenerated");
    } catch (error) {}
  };

  const candidateDetails = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/candidate_dashboard_section_1?jd_id=${id}&candidate_id=${candidateID}`,
        {
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
          },
        }
      );
      setCandidateData(response.data);
    } catch (err) {
      console.error("Error fetching candidate details:", err);
    }
  };

  const candidateDetailsGraphs = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/candidate_dashboard_section_2?jd_id=${id}&candidate_id=${candidateID}`,
        {
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
          },
        }
      );
      setBlockTwoData(response.data);
      setMcqScore(parseInt(response.data.candidate_mcq_stats || 0));
      setInterviewScore(parseInt(response.data.candidate_interview_stats || 0));
      setMcqScoreBar(
        ((response.data.candidate_mcq_stats || 0) / 10).toFixed(1)
      );
      setInterviewScoreBar(
        ((response.data.candidate_interview_stats || 0) / 10).toFixed(1)
      );
      setGlobalMcqScoreBar(
        ((response.data.avg_global_mcq_score || 0) / 10).toFixed(1)
      );
      setGlobalInterviewScoreBar(
        ((response.data.avg_global_interview_score || 0) / 10).toFixed(1)
      );
    } catch (err) {
      console.error("Error fetching graphs:", err);
    }
  };

  const radialBarData = {
    series: [McqScrore, interviewScore],
    options: {
      chart: { type: "radialBar" },
      plotOptions: {
        radialBar: {
          offsetY: 0,
          startAngle: 0,
          endAngle: 360,
          hollow: { margin: 5, size: "30%", background: "transparent" },
          track: {
            show: true,
            strokeWidth: "97%",
            background: "#333",
            opacity: 0.1,
          },
          dataLabels: {
            name: {
              show: true,
              fontSize: "14px",
              fontWeight: "bold",
              color: "#4b5563",
            },
            value: {
              show: true,
              fontSize: "18px",
              fontWeight: "bold",
              color: "#1f2937",
            },
          },
        },
      },
      colors: ["#000", "#0b58d7"],
      labels: ["MCQs Score", "Interview Score"],
      legend: {
        show: true,
        position: "right",
        labels: { colors: "#374151", useSeriesColors: true },
        markers: { size: 8, strokeWidth: 0, shape: "circle" },
        formatter: (seriesName, opts) =>
          `${seriesName}: ${opts.w.globals.series[opts.seriesIndex]}%`,
        itemMargin: { vertical: 7 },
      },
    },
  };

  const groupedBarData = {
    series: [
      { name: "Candidate Score", data: [McqScroreBar, interviewScoreBar] },
      {
        name: "Global Average",
        data: [globalMcqScroreBar, globalInterviewScoreBar],
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
        stacked: false,
        toolbar: { show: false },
      },
      plotOptions: { bar: { horizontal: true, barHeight: "60%" } },
      colors: ["#60a5fa", "#333"],
      dataLabels: { enabled: false },
      xaxis: { categories: ["MCQs Score", "Interview Score"] },
      legend: { position: "top", horizontalAlign: "right" },
      grid: { borderColor: "#e5e7eb" },
      tooltip: { shared: true, intersect: false, theme: "dark" },
    },
  };

  return (
    <div className="relative">
      <div
        ref={pdfRef}
        // className="p-12 gap-6 grid grid-cols-1 lg:grid-cols-3 min-h-[calc(100vh-65px)]"
        className="p-12 gap-6 grid grid-cols-1 min-h-[calc(100vh-65px)]"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="max-w-4xl mx-auto w-full">
          <motion.div
            className="bg-white rounded-3xl shadow-2xl border border-gray-300 overflow-y-auto mb-6"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="w-full p-4 bg-blue-950 text-white rounded-tl-3xl rounded-br-3xl text-xl font-bold text-center">
              Candidate Feedback Report
            </div>

            <div className="flex justify-center mt-6">
              <img
                src={candidateData?.profile_picture}
                alt="Candidate"
                className="w-44 h-44 rounded-full object-cover border-4 border-gray-400 shadow-lg"
              />
            </div>

            {candidateData && (
              <div className="flex flex-col items-center mt-6 text-center space-y-4">
                <p className="text-gray-500 text-sm font-medium">
                  #{candidateData?.candidate_id}
                </p>
                <h2 className="text-4xl font-bold text-gray-900">
                  {candidateData.first_name} {candidateData.last_name}
                </h2>
                <p className="text-gray-600 text-lg">{candidateData.phone}</p>
                <p className="text-gray-600 text-lg">{candidateData.email}</p>
              </div>
            )}

            {candidateData && (
              <div className="flex flex-col items-center mt-6 space-y-2 text-center">
                <p className="text-gray-700 text-lg">
                  Post:{" "}
                  <span className="font-semibold">
                    {candidateData.job_title}
                  </span>
                </p>
                <p className="text-gray-700 text-lg">
                  Company: <span className="font-semibold">QeApps</span>
                </p>
                <p className="text-gray-700 text-lg">
                  Experience:{" "}
                  <span className="font-semibold">
                    {candidateData.experience}
                  </span>
                </p>
              </div>
            )}

            {blockTwoData && blockTwoData.shortlist_status === "Yes" && (
              <motion.div
                className="flex flex-col items-center mt-10 gap-4"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.5 }}
              >
                <p className="text-gray-700 text-lg">
                  <span className="text-green-600 font-bold">Shortlisted</span>
                </p>
                {/* <div>
                  <img
                    src={shortList}
                    alt="Shortlist Stamp"
                    className="w-36 h-28 opacity-90"
                  />
                </div> */}
              </motion.div>
            )}
          </motion.div>

          <motion.div
            className="col-span-2 flex flex-col bg-white rounded-3xl shadow-2xl border border-gray-300 overflow-y-auto"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            style={{ maxHeight: "calc(100vh - 190px)" }}
          >
            <div className="w-full p-4 bg-blue-950 text-white rounded-tl-3xl rounded-br-3xl text-xl font-bold text-center">
              Candidate Top Skills & Overall Feedback
            </div>

            <div className="flex flex-col lg:flex-row justify-between items-center p-6 space-y-6 lg:space-y-0 lg:space-x-6">
              <motion.div
                className="w-full lg:w-1/2 p-4 bg-white rounded-xl shadow-lg border border-gray-300"
                initial={{ scale: 0.9 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.5 }}
              >
                <ReactApexChart
                  options={radialBarData.options}
                  series={radialBarData.series}
                  type="radialBar"
                  height={350}
                />

                <motion.div
                  className="w-full border border-gray-300 py-6 rounded-xl shadow-lg mt-6"
                  initial={{ scale: 0.9 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 0.5 }}
                >
                  {blockTwoData && (
                    <div className="relative w-full flex justify-center items-center gap-2">
                      {[
                        {
                          label: "Overall Score",
                          value: parseInt(blockTwoData?.overall_score || 0),
                        },
                        {
                          label: "Resume Rating",
                          value: parseInt(blockTwoData?.resume_rating || 0),
                        },
                        {
                          label: "Suspicious Activity",
                          value: parseInt(
                            blockTwoData?.suspicious_activity || 0
                          ),
                        },
                      ].map((item, index) => (
                        <motion.div
                          key={index}
                          className="w-28 h-28 flex flex-col justify-center items-center bg-white rounded-full text-blue-700 text-lg shadow-lg border-2 border-blue-300 p-10"
                          whileHover={{ scale: 1.15, rotate: 5 }}
                          transition={{ type: "spring", stiffness: 200 }}
                        >
                          <p className="text-2xl font-bold">{item.value}%</p>
                          <p className="text-gray-600 text-sm mt-1">
                            {item.label}
                          </p>
                        </motion.div>
                      ))}
                    </div>
                  )}
                </motion.div>
              </motion.div>

              {blockTwoData && (
                <motion.div
                  className="w-full lg:w-1/2 p-4 bg-white rounded-xl shadow-lg border border-gray-300"
                  initial={{ scale: 0.9 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 0.5 }}
                >
                  <ReactApexChart
                    options={groupedBarData.options}
                    series={groupedBarData.series}
                    type="bar"
                    height={350}
                  />
                </motion.div>
              )}
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default CandidateDashboard;
